export default {
  "commonHeader.cloud": "Cloud",
  "commonHeader.local": "Local",
  "commonHeader.addDevice": "Add Device",
  "commonHeader.timeSetting": "Time Setting",
  "commonHeader.dataBackup": "Data Backup",
  "commonHeader.notice": "Notice",
  "commonHeader.quickStartGuid": "Quick Start Guid"
};
